import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import Modal from '../components/Modal';
import QRScanner from '../components/QRScanner';
import { immobilisationsAPI } from '../services/api';
import { toast } from 'react-toastify';
import { FiX } from 'react-icons/fi';

const ScanPage = () => {
  const [showScanner, setShowScanner] = useState(false);
  const [scanResult, setScanResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleScan = async (qrData) => {
    try {
      setLoading(true);

      // Extract ID from QR data (assuming format like "/immobilisations/ID" or just "ID")
      const id = qrData.split('/').pop();

      // Record the scan
      await immobilisationsAPI.scan(id);

      // Get the immobilisation details
      const res = await immobilisationsAPI.getById(id);

      setScanResult(res.data);
      toast.success('Immobilisation trouvée');
    } catch (error) {
      toast.error('Impossible de trouver l\'immobilisation');
      console.error('Error:', error);
      setScanResult(null);
    } finally {
      setLoading(false);
    }
  };

  const handleNavigateToDetail = () => {
    if (scanResult) {
      navigate(`/immobilisations/${scanResult.id}`);
    }
  };

  return (
    <div className="app-layout">
      <Sidebar />
      <div className="main-content">
        <Header />
        <div className="page-content">
          <div className="page-header">
            <h1 className="page-title">Scanner QR</h1>
          </div>

          <div className="card" style={{ maxWidth: '600px', margin: '0 auto' }}>
            <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
              <p style={{ color: 'var(--text-light)', fontSize: '1rem' }}>
                Scannez le code QR d'une immobilisation pour accéder à ses détails et enregistrer un scan
              </p>
            </div>

            {!showScanner && !scanResult && (
              <button
                onClick={() => setShowScanner(true)}
                className="btn btn-primary"
                style={{ width: '100%' }}
              >
                Démarrer le scan
              </button>
            )}

            {showScanner && (
              <Modal
                isOpen={showScanner}
                title="Scanner QR"
                onClose={() => {
                  setShowScanner(false);
                  setScanResult(null);
                }}
              >
                <QRScanner
                  onScan={handleScan}
                  onClose={() => {
                    setShowScanner(false);
                    setScanResult(null);
                  }}
                />
              </Modal>
            )}

            {scanResult && (
              <div>
                <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
                  <h3>{scanResult.nom}</h3>
                  <p style={{ color: 'var(--text-light)', marginTop: '0.5rem' }}>
                    Code: {scanResult.id}
                  </p>
                </div>

                {scanResult.photo && (
                  <img
                    src={scanResult.photo}
                    alt={scanResult.nom}
                    style={{
                      width: '100%',
                      height: '300px',
                      objectFit: 'cover',
                      borderRadius: 'var(--radius-md)',
                      marginBottom: '1.5rem',
                    }}
                    onError={(e) => {
                      e.target.src = 'https://via.placeholder.com/400x300?text=No+Image';
                    }}
                  />
                )}

                <div style={{ marginBottom: '1.5rem' }}>
                  <div style={{ marginBottom: '1rem' }}>
                    <label style={{ fontSize: '0.875rem', fontWeight: 600, color: 'var(--text-light)' }}>
                      Catégorie
                    </label>
                    <p>{scanResult.categorie?.nom || 'N/A'}</p>
                  </div>

                  <div style={{ marginBottom: '1rem' }}>
                    <label style={{ fontSize: '0.875rem', fontWeight: 600, color: 'var(--text-light)' }}>
                      Service
                    </label>
                    <p>{scanResult.service?.nom || 'N/A'}</p>
                  </div>

                  <div>
                    <label style={{ fontSize: '0.875rem', fontWeight: 600, color: 'var(--text-light)' }}>
                      État
                    </label>
                    <p>
                      <span
                        className={`badge badge-${
                          scanResult.etat === 'Bon'
                            ? 'success'
                            : scanResult.etat === 'Moyen'
                            ? 'warning'
                            : 'error'
                        }`}
                      >
                        {scanResult.etat}
                      </span>
                    </p>
                  </div>
                </div>

                <div style={{ display: 'flex', gap: '1rem' }}>
                  <button
                    onClick={() => {
                      setShowScanner(false);
                      setScanResult(null);
                    }}
                    className="btn btn-ghost"
                    style={{ flex: 1 }}
                  >
                    Nouveau scan
                  </button>
                  <button
                    onClick={handleNavigateToDetail}
                    className="btn btn-primary"
                    style={{ flex: 1 }}
                  >
                    Voir détails
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScanPage;
